import React from 'react';
import InfoView from '../composer/ui/InfoView';
import { ErrorCode } from './types';
import { getErrorInfoByCode } from './utils';

export default function ErrorInfoView({ code }: { code: ErrorCode }) {
  const { image, title, message } = getErrorInfoByCode(code);

  return <InfoView title={title} message={message} image={image} />;
}
